import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import moment from "moment";
import DatePicker from "react-datepicker";
import { Card, Modal } from 'react-bootstrap';
import "react-datepicker/dist/react-datepicker.css";
import Container from 'react-bootstrap/Container';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
// import { setNewTariff, uploadNewTariff } from './dispatch';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDashboardSuccess, fetchDeleteSearch, fetchEditSearch, fetchSearchData, fetchStatus, fetchSubCategory, fetchSupplierCategory, fetchUnitCategory } from './dashboard/dispatch';
import { setCategoryData } from '../utils/utility';
import Table from 'react-bootstrap/Table'
import Moment from "react-moment";
import { setDataElectricityCharges, setDataNewTariff, setDataOtherCharges } from './NewTariff/action';
import { fetchSearchDataSuccess } from './dashboard/action';
import { setElectricityCharges, setNewTariff, setOtherCharges, uploadNewTariff } from "./NewTariff/dispatch";
export const SerchTariff = (props) => {
    console.log(props)
    // const { data } = useSelector(state => state.loginReducer);
    const data =  JSON.parse(localStorage.getItem("USER_DETAILS")); 

    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [open, setOpen] = useState(false);
    const [newTariffFormData, setnewTariffFormData] = useState({});
    const [TariffValidFrom, setTariffValidFrom] = useState(new Date());
    const [TariffDueDate, setTariffDueDate] = useState(new Date());
    const [errorsMasterValue, setErrorsMasterValue] = useState({});
    const { masterValueData, uploadDataNewTariff } = useSelector(state => state.newTariffReducer);
    const { dashboardData, subCategoryData, supplierTypeData, StatusData, searchData, deleteData } = useSelector(state => state.dashboardReducer);
    useEffect(() => {
        // dispatch(fetchDashboardSuccess(data))
        // setnewTariffFormData(masterValueData)
        dispatch(fetchUnitCategory(data))
        dispatch(fetchStatus(data))
        if (deleteData?.ERROR_STATUS) {
            let sendData = {
                formdata: newTariffFormData,
                userData: data
            }
            dispatch(fetchSearchData(sendData))
        }
        dispatch(fetchSearchDataSuccess(null));
        dispatch(setNewTariff(null))
        dispatch(setElectricityCharges(null))
        dispatch(setOtherCharges(null))
    }, []);
    const dispatch = useDispatch();
    const handleClose = () => {
        setShow(false);
        setOpen(true)
    };
    const handleShow = () => {
        setShow(true);
    };
    const handleChangeDate = (date, event) => {
        // setDate(date);
        console.log(moment);
        setOpen(true)
    };
    const handleClick = () => {
        // props.onClick

    }
    const handleChange = (event, param) => {
        let name = event?.target?.name;
        let value = event?.target?.value;
        if (param == 'TariffValidFrom' ||
            param == 'TariffValidTo') {
            name = param;
            value = moment(event).format("YYYY-MM-DD").toString();
        }

        setnewTariffFormData(values => ({ ...values, [name]: value }))
        console.log(newTariffFormData)
    }
    const validateForm = () => {
        const newErrors = {};
        // if (!newTariffFormData?.TariffName) newErrors.TariffName = 'Tariff Name is required';
        // if (!newTariffFormData?.TariffDescription) newErrors.TariffDescription = 'Tariff Description is required';
        // if (!newTariffFormData?.TariffServiceCategory) newErrors.TariffServiceCategory = 'Tariff Service Category is required';
        // if (!newTariffFormData?.TariffServiceTypeCategory) newErrors.TariffServiceTypeCategory = 'Tariff Service Type Category is required';
        // if (!newTariffFormData?.TariffSubCategoryCategory) newErrors.TariffSubCategoryCategory = 'Tariff Sub Category Category is required';
        // if (!newTariffFormData?.TariffFixedUnit) newErrors.TariffFixedUnit = 'Tariff Fixed Unit is required';
        // if (!newTariffFormData?.TariffFixedSubsidy) newErrors.TariffFixedSubsidy = 'Tariff Fixed Subsidy is required';
        // if (!newTariffFormData?.TariffFixedCharges) newErrors.TariffFixedCharges = 'Tariff Fixed Charges is required';
        // if (!newTariffFormData?.TariffFixedMinimumCharges) newErrors.TariffFixedMinimumCharges = 'Tariff Minimum Charges is required';
        // if (!newTariffFormData?.TariffFixedMaximumCharges) newErrors.TariffFixedMaximumCharges = 'Tariff Maximum Charges is required';
        return newErrors;
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        const formErrors = validateForm();

        if (Object.keys(formErrors).length > 0) {
            setErrorsMasterValue(formErrors);
        } else {
            setErrorsMasterValue({});
            // dispatch(setNewTariff(newTariffFormData))
        }
    };
    const handleDelete = (id) => {
        let userData = { userData: data, id: id }
        dispatch(fetchDeleteSearch(userData))
        setTimeout(() => {
            let sendData = {
                formdata: newTariffFormData,
                userData: data
            }
            dispatch(fetchSearchData(sendData))
        }, 4000);
    };
    const handleEdit = (id) => {
        let userData = { userData: data, id: id }
        dispatch(setDataNewTariff(""));
        dispatch(setDataElectricityCharges(""));
        dispatch(setDataOtherCharges(""));
        dispatch(fetchEditSearch(userData, navigate))
    };
    return (
        <>
            <Card style={{ height: '94px', width: '100%', backgroundColor: '#17234D', borderRadius: '0px' }}>
                <Card.Body>
                    <Card.Title style={{ color: '#fff', fontFamily: "Roboto-Regular", fontSize: '25px' }}>Search Tariff</Card.Title>
                    <Card.Text style={{ color: '#fff', fontFamily: "Roboto-Light", fontSize: '15px' }}>
                        Search  tariff plan with details
                    </Card.Text>
                </Card.Body>
            </Card>
            <Card style={{ boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', margin: '30px' }}>
                <Card.Body style={{ maxHeight: '65vh', overflowY: 'auto', paddingBottom: "5%" }}>
                    <>
                        <Form onSubmit={handleSubmit} >
                            {
                                (data?.pDATASET[0]?.STATE_NAME || data?.pDATASET[0]?.CIRCLE_NAME) ?
                                    <Card style={{ borderWidth: 0, height: '60px', width: '100%', backgroundColor: '#FFF6D6', borderRadius: '0px' }}>
                                        <Container style={{ paddingTop: '10px', }}>
                                            <Row>
                                                <Col sm={2} style={{ fontFamily: "Roboto-Light", fontSize: '13px' }}>State</Col>
                                                <Col sm={2} style={{ fontFamily: "Roboto-Light", fontSize: '13px' }}>Distict</Col>
                                                
                                            </Row>
                                            <Row>
                                                <Col sm={2} style={{ fontFamily: "Roboto-Regular ", fontSize: '15px' }}>{data?.pDATASET[0]?.STATE_NAME}</Col>
                                                <Col sm={2} style={{ fontFamily: "Roboto-Regular", fontSize: '15px' }}>{data?.pDATASET[0]?.CIRCLE_NAME}</Col>
                                                
                                            </Row> </Container> </Card> : null
                            }


                            <Row className="mb-3" >
                                <Form.Group as={Col} controlId="Status">
                                    <Form.Label>Status</Form.Label>
                                    <Form.Select defaultValue="Choose..."
                                        name="Status"
                                        value={newTariffFormData?.Status}
                                        onChange={(e) => { setCategoryData(e?.target?.value); handleChange(e); }}
                                        isInvalid={!!errorsMasterValue.Status}>
                                        <option value="">Please select</option>
                                        {
                                            StatusData?.pDATASET?.map((item) => {
                                                if (item.TYPE == 'STATUS')
                                                    return <option value={item.ID}>{item.NAME}</option>
                                            })
                                        }
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {errorsMasterValue.Status}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} controlId="ServiceCategory">
                                    <Form.Label>Service Category</Form.Label>
                                    <Form.Select defaultValue="Choose..."
                                        name="TariffServiceCategory"
                                        value={newTariffFormData?.TariffServiceCategory}
                                        onChange={(e) => { setCategoryData(e?.target?.value); handleChange(e); dispatch(fetchSubCategory(data, e?.target?.value)); dispatch(fetchSupplierCategory(data, e?.target?.value)) }}
                                        isInvalid={!!errorsMasterValue.TariffServiceCategory}>
                                        <option value="">Please select</option>
                                        {
                                            dashboardData?.pDATASET.map((item) => {
                                                return <option value={item.CATEGORY_ID}>{item.CATEGORY_NAME}</option>
                                            })
                                        }
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {errorsMasterValue.TariffServiceCategory}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} controlId="SubCategory">
                                    <Form.Label>Sub Category</Form.Label>
                                    <Form.Select defaultValue="Choose..."
                                        name="TariffSubCategoryCategory"
                                        onChange={(e) => { handleChange(e); dispatch(fetchSupplierCategory(data, e?.target?.value)) }}
                                        value={newTariffFormData?.TariffSubCategoryCategory}
                                        isInvalid={!!errorsMasterValue.TariffSubCategoryCategory} >
                                        <option value="">Please select</option>
                                        {
                                            subCategoryData?.pDATASET.map((item) => {
                                                return <option value={item.SUBCATEGORY_ID}>{item.SUBCATEGORY_NAME}</option>
                                            })
                                        }
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {errorsMasterValue.TariffSubCategoryCategory}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="SupplierType">
                                    <Form.Label> Supplier Type</Form.Label>
                                    <Form.Select defaultValue="Choose..."
                                        name="TariffSupplierTypeCategory"
                                        onChange={handleChange}
                                        value={newTariffFormData?.TariffSupplierTypeCategory}
                                        isInvalid={!!errorsMasterValue.TariffSupplierTypeCategory}>
                                        <option value="">Please select</option>
                                        {
                                            supplierTypeData?.pDATASET.map((item) => {
                                                return <option value={item.SUPPLIERTYPE_ID}>{item.SUPPLIERTYPE_NAME}</option>
                                            })
                                        }
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {errorsMasterValue.TariffServiceTypeCategory}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} controlId="Tariffname" >
                                    <Form.Label style={{ fontFamily: "Roboto-Light", fontSize: '13px' }}>Tariff name </Form.Label>
                                    <Form.Control placeholder="Tariff name" style={{ width: '100%' }}
                                        value={newTariffFormData?.TariffName}
                                        name="TariffName"
                                        onChange={handleChange}
                                        isInvalid={!!errorsMasterValue.TariffName} />
                                    <Form.Control.Feedback type="invalid">
                                        {errorsMasterValue?.TariffName}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Row>
                            <div style={{ marginTop: 40, marginLeft: '10px' }}>
                                {/* <Button variant="primary" type="submit">
                                    Cancel
                                </Button> */}

                                <Button variant="primary" style={{ marginLeft: 15 }}
                                    onClick={() => {
                                        let sendData = {
                                            formdata: newTariffFormData,
                                            userData: data
                                        }
                                        dispatch(fetchSearchData(sendData))
                                    }}
                                >
                                    Search
                                </Button>
                            </div>
                            <div style={{ marginTop: 10 }}>
                                {console.log(searchData?.pDATASET.length)}
                                {
                                    ((searchData && searchData?.pDATASET) && (searchData?.pDATASET.length != 0)) ? <Table class="table table-striped table-light">
                                        <thead>
                                            <tr>
                                                <th style={{ backgroundColor: '#FFF6D6' }} width="200">Tariff Name</th>
                                                <th style={{ backgroundColor: '#FFF6D6' }} width="200">Category</th>
                                                <th style={{ backgroundColor: '#FFF6D6' }} width="200">Sub_Category</th>
                                                <th style={{ backgroundColor: '#FFF6D6' }} width="200">Supplier Type</th>
                                                <th style={{ backgroundColor: '#FFF6D6' }} width="200">Tariff Period</th>
                                                <th style={{ backgroundColor: '#FFF6D6' }} width="170">Tariff Status</th>
                                                <th style={{ backgroundColor: '#FFF6D6' }} width="200"></th>
                                                <th style={{ backgroundColor: '#FFF6D6' }} width="200"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {searchData && searchData?.pDATASET?.map((listValue, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{listValue?.TARIFF_NAME}</td>
                                                        <td>{listValue?.CATEGORY_NAME}</td>
                                                        <td>{listValue?.SUBCATEGORY_NAME}</td>
                                                        <td>{listValue?.SUPPLIERTYPE_NAME}</td>
                                                        <td>{listValue?.TARIFF_PERIOD}</td>
                                                        <td>{listValue?.TARIFF_STATUS}</td>
                                                        <td>{<Button variant="primary" onClick={() => handleEdit(listValue?.TARIFF_ID)}>Edit </Button>}</td>
                                                        <td>{<Button variant="primary" onClick={() => handleDelete(listValue?.TARIFF_ID)}>Delete </Button>}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table> : (searchData?.pDATASET.length == 0) ? <div style={{textAlign:'center',fontSize:'25px'}}>No Records Found!!</div> : null
                                }
                            </div>

                            
                        </Form>
                    </>
                </Card.Body>
            </Card>
        </>
    );
}

